import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, Package, Euro, TrendingUp } from "lucide-react";
import { api, formatPrice } from "../../lib/api";

const STATUS_LABEL = {
  pending_call: "À rappeler",
  confirmed: "Confirmées",
  preparing: "En préparation",
  en_route: "En livraison",
  delivered: "Livrées",
  cancelled: "Annulées",
};

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get("/admin/orders/stats").then((r) => setStats(r.data));
    api.get("/admin/orders").then((r) => setRecent(r.data.slice(0, 6)));
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <p className="eyebrow mb-2">Vue d'ensemble</p>
      <h1 className="font-display text-4xl text-white leading-none mb-8">
        Tableau de <span className="italic text-gold">bord</span>
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
        <div className="bg-night-2 border border-subtle p-6" data-testid="stat-total-orders">
          <ShoppingBag className="text-[#d4af37] mb-3" size={20} />
          <p className="text-xs uppercase tracking-wider text-gray-500">Commandes</p>
          <p className="font-display text-3xl text-white mt-1">{stats?.total_orders ?? "—"}</p>
        </div>
        <div className="bg-night-2 border border-subtle p-6" data-testid="stat-total-revenue">
          <Euro className="text-[#d4af37] mb-3" size={20} />
          <p className="text-xs uppercase tracking-wider text-gray-500">Chiffre d'affaires</p>
          <p className="font-display text-3xl text-white mt-1">
            {stats ? formatPrice(stats.total_revenue) : "—"}
          </p>
        </div>
        <div className="bg-night-2 border border-subtle p-6" data-testid="stat-pending-calls">
          <TrendingUp className="text-[#d4af37] mb-3" size={20} />
          <p className="text-xs uppercase tracking-wider text-gray-500">À rappeler</p>
          <p className="font-display text-3xl text-white mt-1">
            {stats?.by_status?.pending_call?.count ?? 0}
          </p>
        </div>
        <div className="bg-night-2 border border-subtle p-6" data-testid="stat-delivered">
          <Package className="text-[#d4af37] mb-3" size={20} />
          <p className="text-xs uppercase tracking-wider text-gray-500">Livrées</p>
          <p className="font-display text-3xl text-white mt-1">
            {stats?.by_status?.delivered?.count ?? 0}
          </p>
        </div>
      </div>

      <div className="flex items-center justify-between mb-6">
        <h2 className="font-display text-2xl text-white">Dernières commandes</h2>
        <Link to="/admin/orders" className="text-xs uppercase tracking-[0.2em] text-[#d4af37]">
          Tout voir →
        </Link>
      </div>

      <div className="bg-night-2 border border-subtle overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="border-b border-subtle">
            <tr className="text-left text-[10px] uppercase tracking-[0.2em] text-gray-500">
              <th className="p-4">N°</th>
              <th className="p-4">Client</th>
              <th className="p-4 hidden sm:table-cell">Téléphone</th>
              <th className="p-4 hidden md:table-cell">Zone</th>
              <th className="p-4">Total</th>
              <th className="p-4">Statut</th>
            </tr>
          </thead>
          <tbody>
            {recent.length === 0 ? (
              <tr>
                <td colSpan={6} className="p-8 text-center text-gray-500">Aucune commande pour l'instant.</td>
              </tr>
            ) : (
              recent.map((o) => (
                <tr key={o.id} className="border-b border-white/5 hover:bg-white/5" data-testid={`order-row-${o.id}`}>
                  <td className="p-4 font-mono text-xs">{o.order_number}</td>
                  <td className="p-4">{o.customer_name}</td>
                  <td className="p-4 hidden sm:table-cell">{o.customer_phone}</td>
                  <td className="p-4 hidden md:table-cell">{o.delivery_zone}</td>
                  <td className="p-4 text-gold">{formatPrice(o.total)}</td>
                  <td className="p-4">
                    <span className="text-[10px] uppercase tracking-wider px-2 py-1 border border-[#d4af37]/40 text-[#d4af37]">
                      {STATUS_LABEL[o.status] || o.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminDashboard;
